import React, {useState} from "react";
import {observer} from "mobx-react";
import {Dialog} from '@mui/material';
import DraggableInput from '../Shared/DraggableInput';
import {useStores} from "../../Hooks";
import SaveFileHook from "../../Hooks/SaveFileHook";
import {filter3DFilesBeforeUpload} from "../../serverClientShared/sharedUtils";

const UploadMediaDialog = observer(() => {
    const { modalStore, generalStore, projectStore } = useStores();

    const [dragging, setDragging] = useState(false);

    function closeModal() {
        projectStore.mediaLibraryPathArray = [{
            folderId: 'root',
            folderName: generalStore.translate('root')
        }];
        modalStore.isUploadModalOpen = false;
    }

    const saveFile = SaveFileHook()
    async function saveFileWith3dCheck (files) {
        let errorMessage = null;
        if(modalStore.modalData.no3d){
            const filter3DFilesResponse = filter3DFilesBeforeUpload(files)
            errorMessage = filter3DFilesResponse.errorMessage;
            const filteredFiles = filter3DFilesResponse.files
            if(errorMessage){
                modalStore.showErrorMessage(errorMessage, true);
            }
            if(filteredFiles === null){
                return;
            }
            files = filteredFiles;
        }
        generalStore.isLoaderOpen = true;
        await saveFile(files, null, 0)
        if(errorMessage) {
            modalStore.showErrorMessage(errorMessage, true);
        }
        closeModal();
    }

    return (
        <Dialog
            className={'dialog big-dialog' + (dragging ? ' dragging' : '')}
            open={modalStore.isUploadModalOpen}
            onClose={closeModal}
            fullWidth
            maxWidth='md'
        >
            {modalStore.isUploadModalOpen ? (
                <>
                  <div style={{marginTop: "40px", fontWeight: "700", fontSize:"24px" ,color: "#36415D", display: "flex", justifyContent: "center"}}>{generalStore.translate('uploadMedia')}</div>
                <DraggableInput
                    onInputSelected={saveFileWith3dCheck}
                    onDragStart={() => setDragging(true)}
                    onDragStop={() => setDragging(false)}
                />
                </>) : <></>}
        </Dialog>
    );
});

export default UploadMediaDialog;
